import {Cureus} from '../Cureus';

Cureus.CampaignArticles = {}
//= require_tree ./CampaignArticles